import React, { ReactNode } from "react";
import "./style.scss";

export interface Props {
    className?: string;
    children: ReactNode;
}

/**
 * The description list can be used to show lists of key/value pairs to the user.
 */
export const DescriptionList = ({ className, children }: Props) => {
    const classNames = [];
    if (className) {
        classNames.push(className);
    } else {
        classNames.push("list");
    }
    return <dl className={classNames.join(" ")}>{children}</dl>;
};
export const DescriptionListWithDividers = ({ className, ...rest }: Props) => {
    const classNames = ["divided"];
    if (className) {
        classNames.push(className);
    }
    return <DescriptionList {...rest} className={classNames.join(" ")} />;
};

export const DescriptionListTable = ({ className, ...rest }: Props) => {
    const classNames = ["tbl"];
    if (className) {
        classNames.push(className);
    }
    return <DescriptionList {...rest} className={classNames.join(" ")} />;
};
export const DescriptionListColumnTable = ({ className, ...rest }: Props) => {
    const classNames = ["columned"];
    if (className) {
        classNames.push(className);
    }
    return <DescriptionListTable {...rest} className={classNames.join(" ")} />;
};
export const DescriptionListNarrowTable = ({ className, ...rest }: Props) => {
    const classNames = ["narrow"];
    if (className) {
        classNames.push(className);
    }
    return <DescriptionListTable {...rest} className={classNames.join(" ")} />;
};
